import {Mapper} from '@s-ui/domain'

const DEFAULT_SIZE = 20

export class FromSearchToSearchResultsDealerRequestMapper extends Mapper {
  constructor({config, searchResultsDealerRequest}) {
    super()
    this._searchResultsDealerRequest = searchResultsDealerRequest
    this._config = config
    this._defaultSearch = this._config.get('dealer').DEFAULT_SEARCH
  }

  _getPagination = ({page, size}) => ({
    page: page || this._defaultSearch.page,
    size: size || DEFAULT_SIZE
  })

  _getSort = ({sortBy, sortOrder}) => ({
    term: sortBy?.toLowerCase() || this._defaultSearch.sortBy.toLowerCase(),
    order: sortOrder?.toLowerCase() || this._defaultSearch.sortOrder.toLowerCase()
  })

  map = ({search = {}}) => {
    const {cityId, makeId, provinceId} = search

    return this._searchResultsDealerRequest({
      filters: {
        ...(cityId && {cityId}),
        ...(makeId && {makeId}),
        ...(provinceId && {provinceId})
      },
      pagination: this._getPagination(search),
      sort: this._getSort(search)
    })
  }
}
